import { render, staticRenderFns } from "./section-row.vue?vue&type=template&id=227ef796&scoped=true&"
import script from "./section-row.vue?vue&type=script&lang=js&"
export * from "./section-row.vue?vue&type=script&lang=js&"
import style0 from "./section-row.vue?vue&type=style&index=0&id=227ef796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ef796",
  null
  
)

export default component.exports